
import Component, { mixins } from "vue-class-component";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import { ProxyTableData } from '@/UI/components/Helpers/ProxyTableData';
import { SalaryCalculationsTable } from "@/UI/pages/SalaryСalculations/lib/table";

@Component({
    components: {
        BaseDataForm
    }
})

export default class CosmetologCard extends mixins (ProxyTableData, SalaryCalculationsTable) {

    data: any = []
    columns: any = []
    route: any = this.$route.name

    async getColumns() {
        if (this.route === 'SettlementPerDay') {
            this.columns = this.columnsSettlementPerDay
            for(let i = 0; i < 50; i++) {
                this.data.push(
                    {
                        key0: '12:20',
                        key1: '350',
                        key2: '350',
                        key3: '350',
                        key4: '350',
                    },
                )
            }
        } else {
            this.columns = this.columnsSettlementPerPeriod
            for(let i = 0; i < 2; i++) {
                this.data.push(
                    {
                        key0: '',
                        key1: 'Алена. Косметолог-визажист',
                        key2: '4 дня 45 часов',
                        key3: '4',
                        key4: '9000',
                        key5: '9',
                        key6: '58000',
                        key7: '67000',
                        key8: '11600',
                        key9: '',
                    },
                )
            }
        }
    }

    async created() {
        this.formReady = false
        try {
            await this.getColumns()
        } catch (e) {
            console.error(e)
        } finally {
            this.formReady = true
        }
    }

}
